import { Component, EventEmitter, Output } from '@angular/core'
import { closeJobSelectionDialog } from '../../../shared/utils/job-selection-dialog-utils'
import { PipelineType } from '../../../shared/model/jobs'

@Component({
    selector: 'app-pipeline-selection',
    templateUrl: './pipeline-selection.component.html',
    styleUrls: ['./pipeline-selection.component.scss'],
})
export class PipelineSelectionComponent {
    PipelineTypeEnum = PipelineType

    @Output() selectPipeline = new EventEmitter<PipelineType>()

    selectedPipeline: PipelineType | null = null

    cancel(): void {
        closeJobSelectionDialog()
    }

    select(): void {
        if (this.selectedPipeline) this.selectPipeline.emit(this.selectedPipeline)
    }
}
